import { Text, Tooltip } from '@mantine/core';

interface SatisfactionTier {
  color: string;
  label: string;
}

function getSatisfactionTier(rating: number): SatisfactionTier {
  if (rating >= 4.5) return { color: '#28463A', label: 'Very satisfied' };
  if (rating >= 3.5) return { color: '#4A7C59', label: 'Satisfied' };
  if (rating >= 2.5) return { color: '#E9A23B', label: 'Neutral' };
  if (rating >= 1.5) return { color: '#E07B4C', label: 'Dissatisfied' };
  return { color: '#D64545', label: 'Very dissatisfied' };
}

interface CoachSatisfactionRatingProps {
  rating: number | null;
  surveyCount?: number;
}

export function CoachSatisfactionRating({ rating, surveyCount = 0 }: CoachSatisfactionRatingProps) {
  if (rating === null || rating === undefined) {
    return <Text size="sm" c="dimmed">—</Text>;
  }

  const numRating = Number(rating);
  if (isNaN(numRating)) {
    return <Text size="sm" c="dimmed">—</Text>;
  }

  const tier = getSatisfactionTier(numRating);
  const tooltipLabel = `${tier.label} — based on ${surveyCount} survey${surveyCount !== 1 ? 's' : ''}`;

  return (
    <Tooltip label={tooltipLabel} withArrow>
      <Text size="sm" fw={500} style={{ color: tier.color, cursor: 'default' }}>
        {numRating.toFixed(1)}/5
      </Text>
    </Tooltip>
  );
}
